var $ = require('jquery');
require('slick-carousel');

$('.dd-hero__slider')
  .slick({
    dots: true,
    arrows: true,
    speed: 1000,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'cubic-bezier(.16,.66,.3,.99)',
    infinite: true,
    autoplay: true
  })

